import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.split.js";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export function OptionLabel(_ref) {
  var label = _ref.label,
    search = _ref.search;
  if (!search) {
    return _jsx("span", {
      "aria-hidden": true,
      children: label
    });
  }
  var separator = '**';
  var escapedSearch = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  var regex = new RegExp(escapedSearch, 'gi');
  var replacedLabel = label.replace(regex, function (match) {
    return "".concat(separator).concat(match).concat(separator);
  });
  return _jsx("span", {
    "aria-hidden": true,
    children: replacedLabel.split(separator).map(function (item, i) {
      return item.toLowerCase() === search.toLowerCase() ? _jsx("b", {
        children: item
      }, i) : item;
    })
  });
}